"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _core = require("@material-ui/core");
var _Mail = _interopRequireDefault(require("@material-ui/icons/Mail"));
var _styles = require("@material-ui/core/styles");
var _reactRouterDom = require("react-router-dom");
var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _helpers = require("react-platform-components/dist/helpers");
var _axios = _interopRequireDefault(require("react-platform-components/dist/axios"));
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MessageNotifier = function MessageNotifier(props) {
  var intl = props.intl;
  var history = (0, _reactRouterDom.useHistory)();
  var theme = (0, _styles.useTheme)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var isMobile = (0, _core.useMediaQuery)(function (theme) {
    return theme.breakpoints.down('md');
  }, {
    noSsr: true
  });
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFirstTimeFetchingNotificationsInProgress = _useState4[0],
    setFirstTimeFetchNotificationsInProgress = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFetchingNotificationsInProgress = _useState6[0],
    setFetchNotificationsInProgress = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isMarkingNotificationsAsReadInProgress = _useState8[0],
    setMarkNotificationsAsReadInProgress = _useState8[1];
  var _useState9 = (0, _react.useState)({
      notifications: [],
      notificationsTotalCount: null,
      unreadMessagesCount: 0
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    _useState10$ = _useState10[0],
    notifications = _useState10$.notifications,
    notificationsTotalCount = _useState10$.notificationsTotalCount,
    unreadMessagesCount = _useState10$.unreadMessagesCount,
    setState = _useState10[1];
  var anchorRef = (0, _react.useRef)(null);
  _moment.default.locale(intl.locale);
  var prevOpen = (0, _react.useRef)(open);
  (0, _react.useEffect)(function () {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  (0, _react.useEffect)(function () {
    checkUnreadMessages();
    // we check the unred messages every 30 seconds
    var intervalId = setInterval(function () {
      checkUnreadMessages();
    }, 300000);
    return function () {
      return intervalId && clearInterval(intervalId);
    };
  }, []);

  /**
   * use for open and close the popup
   */
  var handleToggle = function handleToggle() {
    if (!open) {
      var params = {
        _page: 1,
        _per_page: 10,
        _sort: '-created_at'
      };
      // fetch the notifications for first time when we open the popup
      fetchNotifications(params);
    } else {
      // when we close the popup we clear the state of the notifications
      setTimeout(function () {
        setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            notifications: [],
            notificationsTotalCount: null
          });
        });
      }, 300);
    }
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };

  /**
   * use for close the popup
   * @param {Event} event 
   */
  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    // when we close the popup we clear the state of the notifications
    setTimeout(function () {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          notifications: [],
          notificationsTotalCount: null
        });
      });
    }, 300);
  };

  /**
   * use this method to redirect to the chat
   */
  var handleShowAllMessagesClick = function handleShowAllMessagesClick() {
    if (open) {
      handleToggle();
    }
    history.push('/chat');
  };

  /**
   * use this method for make the clicked notification read and redirect to the chat
   * @param {Object} notification 
   */
  var handleNotificationClick = function handleNotificationClick(notification) {
    return function (event) {
      if (notification.status === 'unread') {
        markNotificationAndMessageAsRead(notification, function () {
          var _notification$message, _notification$message2;
          setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              unreadMessagesCount: prevState.unreadMessagesCount - 1,
              notifications: _toConsumableArray(_lodash.default.map(prevState.notifications, function (element) {
                return element.id === notification.id ? _objectSpread(_objectSpread({}, element), {}, {
                  status: 'read'
                }) : element;
              }))
            });
          });
          // close the popup
          if (open) {
            handleToggle();
          }
          // redirect to the conversation
          history.push("/chat/".concat(((_notification$message = notification.message) === null || _notification$message === void 0 ? void 0 : (_notification$message2 = _notification$message.conversation) === null || _notification$message2 === void 0 ? void 0 : _notification$message2.id) || ""));
        });
      } else {
        var _notification$message3, _notification$message4;
        // close the popup
        if (open) {
          handleToggle();
        }
        // redirect to the conversation
        history.push("/chat/".concat(((_notification$message3 = notification.message) === null || _notification$message3 === void 0 ? void 0 : (_notification$message4 = _notification$message3.conversation) === null || _notification$message4 === void 0 ? void 0 : _notification$message4.id) || ""));
      }
    };
  };

  /**
   * we use this method to get the count of unread notifications
   */
  var checkUnreadMessages = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get("".concat(_config.BASE_API_URL, "notifications"), {
              params: {
                action: 'ui-message',
                _page: 1,
                _per_page: 1,
                status: 'unread',
                _fields: ['status']
              }
            });
          case 3:
            response = _context.sent;
            setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                unreadMessagesCount: parseInt(response.headers['x-total-count'], 10)
              });
            });
            _context.next = 9;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function checkUnreadMessages() {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * we use this method to make all notification read
   */
  var markedAllMessagesAsRead = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _iterator, _step, _loop;
      return _regeneratorRuntime().wrap(function _callee2$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setMarkNotificationsAsReadInProgress(true);
            _iterator = _createForOfIteratorHelper(notifications);
            _context3.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var notification;
              return _regeneratorRuntime().wrap(function _loop$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    notification = _step.value;
                    if (notification.status === 'unread') {
                      markNotificationAndMessageAsRead(notification, function () {
                        setState(function (prevState) {
                          return _objectSpread(_objectSpread({}, prevState), {}, {
                            unreadMessagesCount: prevState.unreadMessagesCount - 1,
                            notifications: _toConsumableArray(_lodash.default.map(prevState.notifications, function (element) {
                              return element.id === notification.id ? _objectSpread(_objectSpread({}, element), {}, {
                                status: 'read'
                              }) : element;
                            }))
                          });
                        });
                      });
                    }
                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }, _loop);
            });
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context3.next = 9;
              break;
            }
            return _context3.delegateYield(_loop(), "t0", 7);
          case 7:
            _context3.next = 5;
            break;
          case 9:
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t1 = _context3["catch"](2);
            _iterator.e(_context3.t1);
          case 14:
            _context3.prev = 14;
            _iterator.f();
            return _context3.finish(14);
          case 17:
            setMarkNotificationsAsReadInProgress(false);
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee2, null, [[2, 11, 14, 17]]);
    }));
    return function markedAllMessagesAsRead() {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * we use this method to fetch the notifications when we scroll
   * @param {number} page the current page 
   */
  var loadMoreNotifications = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(page) {
      var params;
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            params = {
              _page: page + 1,
              _per_page: 10,
              _sort: '-created_at'
            };
            _context4.next = 3;
            return fetchNotifications(params);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee3);
    }));
    return function loadMoreNotifications(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * we use this method to fetch the notfications
   * @param {object} params parameters of the request contains _page, _per_page, _sort, ...etc
   * @param {Function} onSuccess on success callback
   * @param {Function} onError on error callback
   */
  var fetchNotifications = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var params,
        onSuccess,
        onError,
        response,
        _args5 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            params = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {
              _page: 1,
              _per_page: 10,
              _sort: '-created_at'
            };
            onSuccess = _args5.length > 1 ? _args5[1] : undefined;
            onError = _args5.length > 2 ? _args5[2] : undefined;
            if (params._page === 1) {
              setFirstTimeFetchNotificationsInProgress(true);
            } else {
              setFetchNotificationsInProgress(true);
            }
            _context5.prev = 4;
            _context5.next = 7;
            return _axios.default.get("".concat(_config.BASE_API_URL, "notifications"), {
              params: _objectSpread({
                action: 'ui-message',
                _embed: ['message']
              }, params)
            });
          case 7:
            response = _context5.sent;
            // save the notifications in our state
            setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                notifications: params._page === 1 ? response.data : [].concat(_toConsumableArray(prevState.notifications), _toConsumableArray(response.data)),
                notificationsTotalCount: parseInt(response.headers['x-total-count'], 10)
              });
            });
            onSuccess && onSuccess();
            _context5.next = 15;
            break;
          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](4);
            onError && onError();
          case 15:
            if (params._page === 1) {
              setFirstTimeFetchNotificationsInProgress(false);
            } else {
              setFetchNotificationsInProgress(false);
            }
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee4, null, [[4, 12]]);
    }));
    return function fetchNotifications() {
      return _ref4.apply(this, arguments);
    };
  }();

  /**
   * we use this method for make a notification read
   * @param {number} id notification id
   * @param {Function} onSuccess on success callback
   * @param {Function} onError on error callback
   */
  var markNotificationAndMessageAsRead = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(notification, onSuccess, onError) {
      return _regeneratorRuntime().wrap(function _callee5$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return _axios.default.patch("".concat(_config.BASE_API_URL, "notifications/").concat(notification.id), {
              status: 'read'
            });
          case 3:
            _context6.next = 5;
            return _axios.default.patch("".concat(_config.BASE_API_URL, "messages/").concat(notification.message.id), {
              status: 'read'
            });
          case 5:
            onSuccess && onSuccess();
            _context6.next = 11;
            break;
          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            onError && onError();
          case 11:
          case "end":
            return _context6.stop();
        }
      }, _callee5, null, [[0, 8]]);
    }));
    return function markNotificationAndMessageAsRead(_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var width = isMobile ? '98vw' : 400;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "cart",
    style: {
      color: theme.palette.primary.contrastText
    },
    ref: anchorRef,
    "aria-controls": open ? 'menu-list-grow' : undefined,
    "aria-haspopup": "true",
    onClick: handleToggle
  }, /*#__PURE__*/_react.default.createElement(_core.Badge, {
    badgeContent: unreadMessagesCount,
    color: "error"
  }, /*#__PURE__*/_react.default.createElement(_Mail.default, null))), /*#__PURE__*/_react.default.createElement(_core.Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref6) {
    var TransitionProps = _ref6.TransitionProps,
      placement = _ref6.placement;
    return /*#__PURE__*/_react.default.createElement(_core.Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      elevation: 3
    }, isFirstTimeFetchingNotificationsInProgress ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 12,
      style: {
        paddingTop: 20,
        paddingBottom: 20,
        justifyContent: "center",
        width: width
      }
    }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
      color: theme.palette.primary.main,
      type: "bars",
      height: 35,
      width: 35
    }))) : _lodash.default.isEmpty(notifications) ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 12,
      style: {
        paddingTop: 30,
        paddingBottom: 30,
        justifyContent: "center",
        width: width
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body1"
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Il n'y a aucun message \xE0 afficher",
      defaultMessage: "Il n'y a aucun message \xE0 afficher"
    })))) : !_lodash.default.isEmpty(notifications) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      xs: 12,
      style: {
        padding: "15px 15px 15px 30px",
        justifyContent: "flex-end"
      }
    }, unreadMessagesCount > 0 && /*#__PURE__*/_react.default.createElement(_core.Button, {
      size: "small",
      color: "primary",
      variant: "outlined",
      onClick: markedAllMessagesAsRead,
      disabled: isMarkingNotificationsAsReadInProgress
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Tout marquer comme lu",
      defaultMessage: "Tout marquer comme lu"
    })))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.List, {
      style: {
        maxHeight: 300,
        width: width,
        overflow: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
      pageStart: 0,
      hasMore: notificationsTotalCount > notifications.length && !isFetchingNotificationsInProgress,
      loadMore: loadMoreNotifications,
      useWindow: false
    }, _lodash.default.map(notifications, function (notification) {
      var _notification$message5, _notification$message6, _notification$message7, _notification$message8, _notification$message9, _notification$message10, _notification$message11, _notification$message12, _notification$message13, _notification$message14, _notification$message15, _notification$message16, _notification$message17, _notification$message18;
      return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
        alignItems: "flex-start",
        key: notification.id,
        style: {
          background: notification.status === 'unread' ? '#607d8b26' : '#fff'
        },
        role: undefined,
        button: true,
        onClick: handleNotificationClick(notification)
      }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, (_notification$message5 = notification.message) !== null && _notification$message5 !== void 0 && (_notification$message6 = _notification$message5.user) !== null && _notification$message6 !== void 0 && (_notification$message7 = _notification$message6.avatar) !== null && _notification$message7 !== void 0 && _notification$message7.original ? /*#__PURE__*/_react.default.createElement(_core.Avatar, {
        alt: (_notification$message8 = notification.message) === null || _notification$message8 === void 0 ? void 0 : (_notification$message9 = _notification$message8.user) === null || _notification$message9 === void 0 ? void 0 : _notification$message9.first_name,
        src: (0, _helpers.joinPaths)(_config.BASE_URL, (_notification$message10 = notification.message) === null || _notification$message10 === void 0 ? void 0 : (_notification$message11 = _notification$message10.user) === null || _notification$message11 === void 0 ? void 0 : (_notification$message12 = _notification$message11.avatar) === null || _notification$message12 === void 0 ? void 0 : _notification$message12.original)
      }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, null, (_notification$message13 = notification.message) === null || _notification$message13 === void 0 ? void 0 : (_notification$message14 = _notification$message13.user) === null || _notification$message14 === void 0 ? void 0 : (_notification$message15 = _notification$message14.first_name[0]) === null || _notification$message15 === void 0 ? void 0 : _notification$message15.toUpperCase())), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
        primary: _lodash.default.truncate((_notification$message16 = notification.message) === null || _notification$message16 === void 0 ? void 0 : _notification$message16.body, {
          length: 100
        }),
        secondary: "from: ".concat(notification === null || notification === void 0 ? void 0 : (_notification$message17 = notification.message) === null || _notification$message17 === void 0 ? void 0 : (_notification$message18 = _notification$message17.user) === null || _notification$message18 === void 0 ? void 0 : _notification$message18.first_name)
      }), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "caption"
      }, _moment.default.utc(notification.created_at).fromNow())));
    })), isFetchingNotificationsInProgress && /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      alignItems: "flex-start",
      style: {
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
      color: theme.palette.primary.main,
      type: "bars",
      height: 30,
      width: 30
    })))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        padding: "20px 40px 20px 40px"
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disableElevation: true,
      size: "small",
      onClick: handleShowAllMessagesClick
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Mes conversations",
      defaultMessage: "Mes conversations"
    })))))));
  }));
};
var _default = (0, _Translations.injectIntl)(MessageNotifier);
exports.default = _default;